<main
    class="bg-cover bg-center bg-no-repeat h-screen w-full flex items-center justify-center lg:grid grid-cols-2"
    style="background-image: url('./assets2023/img/bg_login.jpg');"
>

    <div class="bg-white rounded-lg lg:rounded-none m-8 lg:m-0 py-12 px-6 lg:pb-3 lg:pt-20 shadow max-h-90vh lg:max-h-screen lg:h-full overflow-y-auto lg:flex flex-col items-center justify-center">

        <div class="max-w-300px lg:h-full flex flex-col">
            <!-- Main Image -->
            <div class="flex justify-center mb-6 lg:mb-12">
                <img src="./assets2023/img/logo.svg" alt="Logo" class="w-75px lg:w-145px h-55px lg:h-100px" />
            </div>
            <!-- END Main Image -->

            <!-- Title -->
            <h1 class="text-2xl font-bold text-center">
                {{ 'login_access' | translate }}
            </h1>
            <!-- END Title -->

            <ng-container *ngIf="!redirectParams">
                <form
                    class="flex flex-col space-y-5 mt-6 text-sm"
                    (ngSubmit)="onSubmit()">
                    <!-- User -->
                    <div>
                    <label for="username">
                        {{ 'login_user' | translate | titleCase }}
                    </label>
                    <div class="relative w-full">
                        <input
                            type="text"
                            name="username"
                            [(ngModel)]="username"
                            placeholder="{{ 'login_user' | translate | titleCase }}"
                            class="mt-1 w-full rounded-lg border border-light focus:outline-light-blue px-2 h-45px pr-10"
                            autocomplete="off"
                            autocorrect="off"
                            autocapitalize="none"
                            tabindex="1"
                        />
                        <div class="absolute inset-y-0 right-0 flex items-center">
                            <ng-container *ngIf="username">
                                <a
                                    (click)="username=''"
                                    class="mt-1 mx-3 group w-6 h-6 bg-primary hover:bg-white rounded-full flex items-center justify-center border border-primary"
                                >
                                    <svg class="fill-white group-hover:fill-primary" width="8" height="8" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M0.306008 0.306008C0.714019 -0.102003 1.37557 -0.102003 1.78359 0.306008L4 2.52242L6.21632 0.306106C6.62433 -0.101905 7.28578 -0.101905 7.69389 0.306106C8.1019 0.714117 8.1019 1.37567 7.69389 1.78368L5.47758 3.99995L7.69389 6.21627C8.1019 6.62428 8.1019 7.28583 7.69389 7.69384C7.28588 8.10186 6.62433 8.10186 6.21632 7.69384L4 5.47753L1.78359 7.69399C1.37557 8.102 0.714019 8.102 0.306008 7.69399C-0.102003 7.28598 -0.102003 6.62443 0.306008 6.21641L2.52247 3.99995L0.306057 1.78354C-0.102003 1.37553 -0.102003 0.714019 0.306008 0.306008Z"/>
                                    </svg>
                                </a>
                            </ng-container>
                        </div>
                    </div>
                    <p
                        *ngIf="!username && intentSend && !loading"
                        class="text-featured text-xs" id="username-error"
                    >
                    {{ 'login_username_required' | translate }}
                    </p>
                </div>

                <!-- Password -->
                <div>
                    <label for="password">
                        {{ 'login_password' | translate | titleCase }}
                    </label>
                    <input
                        type="password"
                        name="password"
                        tabindex="2"
                        [(ngModel)]="password"
                        placeholder="{{ 'login_password' | translate | titleCase }}"
                        autocomplete="off"
                        class="mt-1 w-full rounded-lg border border-light focus:outline-light-blue px-2 h-45px">
                        <p
                            *ngIf="!password && intentSend && !loading"
                            class="text-featured text-xs"
                            >
                            {{ 'login_password_required' | translate }}
                        </p>
                </div>


                <!-- Remember Password -->
                <div class="text-xs font-medium">
                    <div class="flex items-center gap-2">

                        <input
                            type="checkbox"
                            name="remember"
                            id="remember"
                            tabindex="3"
                            [(ngModel)]="rememberLoginChecked"
                        />
                        <label for="remember" class="mt-px cursor-pointer">{{ 'login_check_label' | translate }}</label>
                    </div>
                </div>

                <!-- Remember Password Link -->
                <div class="text-xs font-bold">
                    <a href="javascript:;" (click)="goRememberPass($event)">
                        {{ 'login_remember_password' | translate }}
                    </a>
                </div>

                <!-- error message hidden by default -->
                <app-alert-text *ngIf="msgLogin" type="error">{{ msgLogin }}</app-alert-text>


                <!-- Submit button -->
                <div class="grid">
                    <button
                        type="submit"
                        class="flex items-center text-white bg-secondary border-secondary hover:opacity-75 font-semibold text-md rounded border transition duration-300 px-8 h-45px justify-center"
                        [ngClass]="{'cursor-not-allowed opacity-75': loading}"
                        [disabled]="loading"
                        tabindex="4"
                    >
                        <app-spinner *ngIf="loading" [onlySVG]="true" color="text-white"></app-spinner>
                        {{ 'login_access' | translate }}
                    </button>
                </div>
                </form>

                <div class="mt-9 space-y-6 w-full">
                    <div class="flex items-center justify-center">
                        <div class="flex-grow h-px bg-light"></div>
                        <span class="mx-3 text-xs text-tertiary">
                            {{ 'login_new_user' | translate }}
                        </span>
                        <div class="flex-grow h-px bg-light"></div>
                    </div>

                    <div class="bg-white text-secondary border-secondary hover:text-primary hover:border-primary font-semibold text-md rounded border transition duration-300 h-45px">
                        <a href="javascript:;" (click)="goRegister($event)" class="w-full h-full flex items-center justify-center hover:no-underline hover:opacity-100">
                            {{ 'login_new_account' | translate }}
                        </a>
                    </div>
                </div>
            </ng-container>

            <ng-container *ngIf="redirectParams">
                <app-spinner></app-spinner>
            </ng-container>

            <app-languages-links class="hidden lg:flex flex-1 justify-center items-end mt-9 lg:pb-12"></app-languages-links>

            <div style="text-align:center; font-size:10px;">v.202607201742</div>
        </div>

    </div>

    <div class="hidden lg:block bg-cover bg-center bg-no-repeat h-full w-full pl-32" style="background-image: url('./assets2023/img/bg_triangles.png');">
        <div class="flex justify-end items-end h-full">
            <div class="text-white text-xs text-right max-w-400px pr-9 xl:pr-14 py-9">
                Si no recuerdas tus claves haz clic en "<b>no recuerdas tu contraseña</b>" o llámanos al teléfono: <b>965 494 000</b>.
            </div>
        </div>
    </div>
</main>
<!-- END Principal content -->

